import "core-js/modules/es6.function.name";
import { __assign, __awaiter, __extends, __generator } from "tslib";
import BaseRepository from '@/core/standard/BaseRepository';
import { axiosInstance } from '@/setup/axios/AxiosConfig'; // TODO: Cambiar a un modelo

var AuthServices =
/** @class */
function (_super) {
  __extends(AuthServices, _super);

  function AuthServices() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.collection = 'auth';
    _this.version = 'v1';
    return _this;
  }

  AuthServices.prototype.getPermissions = function (params) {
    return this.request(__assign(__assign({}, params), {
      url: 'get_permission',
      version: 'v2'
    }));
  };

  AuthServices.prototype.resetPassword = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.request(__assign(__assign({}, params), {
              url: 'reset_password'
            }))];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  AuthServices.prototype.logout = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.request(__assign(__assign({}, params), {
              url: 'logout',
              method: 'POST'
            }))];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  AuthServices.prototype.login = function (params, toast) {
    return __awaiter(this, void 0, void 0, function () {
      var login;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.request({
              method: 'post',
              url: 'login',
              query: params
            })];

          case 1:
            login = _a.sent();

            if (login.token) {
              return [2
              /*return*/
              , login];
            } else {
              toast.error(login.response.message.name[0]);
            }

            return [2
            /*return*/
            , {
              complete: false
            }];
        }
      });
    });
  };

  return AuthServices;
}(BaseRepository);

export default new AuthServices(axiosInstance);